module.exports = __webpack_public_path__ + "img/vr_m_3.c7bc7b21.jpg";